import moment from 'moment';
import Axios, { BackendAxios } from "../interceptors/axiosInstance";
import { http_request } from "../interceptors/httpHandler";
import Request from "../interceptors/Request";

const PlanService = new Request(Axios)

export const getAllPlansByRegion = () => {
    return http_request("/masterdata/masterController/findAllPlan", "POST", {}, false).then(response => response.payload);
}

export const getPlanById = (id) => {
    return http_request(`/masterdata/masterController/findPlanById`, "POST", {
        data: id
    }, true);
}

export const findRegionWisePlanByRegion = (regionId) => {
    // return http_request("/masterdata/masterController/findRegionWisePlanByRegion", 'POST', { regionId }, false);
    return PlanService.post("/masterdata/masterController/findRegionWisePlanByRegion", { regionId }, { checkToken: false })
}


export const uploadOfferCode = (formData) => {
    return http_request("/FileUpload/uploadOfferCode", 'POST', formData, true, {}, {}, BackendAxios)
}

export const getAllInvoice = ({ fromDate, jwt, toDate }) => {
    fromDate = moment(fromDate).add(1, 'day').utc().startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]')
    toDate = moment(toDate).add(1, 'day').utc().endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]')
    return http_request("/Invoice/getAllInvoice", 'POST', { fromDate, jwt, toDate }, true, {}, {}, BackendAxios)
}

export const updateOrder = invoiceId => {
    return http_request("/PlanBilling/updateOrder", 'POST', { invoiceId }, true, {}, {}, BackendAxios)
}


export const getTotalCountByCreatedAt = data => {
    return http_request("/PlanBilling/getTotalCountByCreatedAt", 'POST', data, true, {}, {}, BackendAxios)
}

export const getOfferCodeCountByOfferIdentifier = data => {
    return http_request('/PlanBilling/getOfferCodeCountByOfferIdentifier', 'POST', data, true, {}, {}, BackendAxios)
}

export const createMessageTempate = data => {
    return http_request("/rest/v1/message_template", 'POST', data, true, {}, {}, Axios)
}

export const getOfferCodesByOfferIdentifier = offer_identifier => {
    return http_request(`/rest/v1/offer_code?select=*&offer_identifier=eq.${offer_identifier}&is_static=eq.0`, 'GET', true, {}, {}, Axios)
}

export const getMessageTemplateByOfferIndentifier = offer_identifier => {
    return http_request(`/rest/v1/message_template?select=*&offer_identifier=eq.${offer_identifier}&is_deleted=eq.0&is_active=eq.1`, 'GET', true, {}, {}, Axios)
}


export const getMessageTemplateById = (id) => {
    return http_request(`/rest/v1/message_template?select=*&id=eq.${id}`, 'GET', true, {}, {}, Axios)
}

export const updateMessageTemplate = (id, data) => {
    return http_request(`/rest/v1/message_template?id=eq.${id}`, 'PATCH', data, true, {}, {}, Axios)
}

export const testTemplate = data => {
    return http_request("/Template/testTemplate", 'POST', data, true, {}, {}, BackendAxios)
}